import { v4 as uuidv4 } from 'uuid';
import { Base64 } from 'js-base64';
import moment from 'moment';
moment.locale('zh_cn');

export const makeUUID = function () {
  return uuidv4().replace(/-/g, '');
}
export const dateTime = function (date, formatType = 'YYYY-MM-DD') {
  formatType = typeof formatType == 'string' ? formatType : 'YYYY年MM月DD日 HH:mm:ss';
  var res = moment(date).format(formatType);
  return res;
}
export const toBase64String = function (str) {
  return Base64.encodeURI(str);
}
export default { makeUUID, dateTime, toBase64String, };